'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BookingTimeCard = require('./BookingTimeCard');

var _BookingTimeCard2 = _interopRequireDefault(_BookingTimeCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BookingTime = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(BookingTime, _Component);

  function BookingTime() {
    (0, _classCallCheck3.default)(this, BookingTime);
    return (0, _possibleConstructorReturn3.default)(this, (BookingTime.__proto__ || (0, _getPrototypeOf2.default)(BookingTime)).apply(this, arguments));
  }

  (0, _createClass3.default)(BookingTime, [{
    key: 'selectBooking',
    value: function selectBooking(data) {
      this.props.onChange(data);
    }
  }, {
    key: 'renderItem',
    value: function renderItem(item, i) {
      var _this2 = this;

      var _props$data = this.props.data,
          bookingTimeId = _props$data.bookingTimeId,
          shop = _props$data.shop;

      var data = (0, _extends3.default)({}, item, {
        shop: shop,
        selected: bookingTimeId
      });
      return _react2.default.createElement(_BookingTimeCard2.default, {
        key: 'card_' + i,
        data: data,
        onClick: function onClick() {
          return _this2.selectBooking(data);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./BookingTime.scss');
      var bookingTime = this.props.data.bookingTime;

      var morning = bookingTime.filter(function (v) {
        return v.time < 720;
      });
      var afternoon = bookingTime.filter(function (v) {
        return v.time >= 720;
      });
      return _react2.default.createElement(
        'div',
        { className: '' + styles.bookingTime },
        !!(morning && morning.length) && _react2.default.createElement(
          'div',
          { className: styles.blockTime + ' ' + styles.borderBottom },
          _react2.default.createElement(
            'h3',
            null,
            'S\xE1ng'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.times },
            morning.map(function (v, i) {
              return _this3.renderItem(v, i);
            })
          )
        ),
        !!(afternoon && afternoon.length) && _react2.default.createElement(
          'div',
          { className: styles.blockTime },
          _react2.default.createElement(
            'h3',
            null,
            'Chi\u1EC1u / T\u1ED1i'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.times },
            afternoon.map(function (v, i) {
              return _this3.renderItem(v, i);
            })
          )
        ),
        (!bookingTime || bookingTime.length === 0) && _react2.default.createElement(
          'div',
          { className: styles.blockTime },
          _react2.default.createElement(
            'div',
            { className: styles.card },
            'H\u1EBFt Ch\u1ED7'
          )
        )
      );
    }
  }]);
  return BookingTime;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  onChange: _react.PropTypes.func
}, _temp);
exports.default = BookingTime;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/BookingTime.js
// module id = 1551
// module chunks = 0